<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('label.fileCode')">
              <j-input :placeholder="$t('label.pleaseEnterTheFileCode')"  v-model="queryParam.code"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('label.fileDescription')">
              <j-input :placeholder="$t('label.pleaseEnterTheFileDescription')"  v-model="queryParam.name"></j-input>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('label.validOrNot')">
                <j-dict-select-tag  :placeholder="$t('label.pleaseChooseWhetherItIsValidOrNot')" v-model="queryParam.validFlag" dictCode="sfyx"/>
              </a-form-item>
            </a-col>
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{$t('button.search')}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{$t('button.reset')}}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('tip.up') : $t('tip.down') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{$t('button.add')}}</a-button>
      <a-button v-show=false type="primary" icon="download" @click="handleExportXls('efs_md_archives')">{{$t('button.export')}}</a-button>
      <a-upload v-show=false name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">{{$t('button.import')}}</a-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{$t('button.delete')}}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{$t('button.batchOperation')}} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{$t('tip.selected')}} <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>{{$t('tip.term')}}
        <a style="margin-left: 24px" @click="onClearSelected">{{$t('button.clear')}}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template v-for="(item, index) in columns" :slot="item.slotName">
          <span :key="index">{{ $t(item.slotName) }}</span>
        </template>

        <template :slot="item.dataIndex" slot-scope="text, record" v-for="item in columns">
          <mtc-lang-list-popover :key="item.dataIndex" :record="record" :item="item" :text="text" />
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{$t('button.edit')}}</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{$t('button.more')}} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">{{$t('button.details')}}</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm :title="$t('tip.isDelete')" @confirm="() => handleDelete(record.id)">
                  <a>{{$t('button.delete')}}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <efs-md-archives-modal ref="modalForm" @ok="modalFormOk"></efs-md-archives-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import EfsMdArchivesModal from './modules/EfsMdArchivesModal'
  import JDictSelectTag from '@/components/dict/JDictSelectTag.vue'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import JInput from '@/components/jeecg/JInput'

  export default {
    name: 'EfsMdArchivesList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      JDictSelectTag,
      EfsMdArchivesModal,
      JInput
    },
    data () {
      return {
        mainTable: 'efs_md_archives',
        description: '费用项档案管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            slotName: 'tableHeader.fileType',
            scopedSlots: { title: 'tableHeader.fileType'},
            align:"center",
            dataIndex: 'archType_dictText'
          },
          {
            slotName: 'tableHeader.fileCode',
            scopedSlots: { title: 'tableHeader.fileCode'},
            align:"center",
            dataIndex: 'code'
          },
          {
            slotName: 'tableHeader.fileDescription',
            align:"center",
            dataIndex: 'name',
            scopedSlots: { customRender: 'name', title: 'tableHeader.fileDescription'}
          },
          {
            slotName: 'tableHeader.costItemClassification',
            scopedSlots: { title: 'tableHeader.costItemClassification'},
            align:"center",
            dataIndex: 'categoryCode_dictText'
          },
          {
            slotName: 'tableHeader.validOrNot',
            scopedSlots: { title: 'tableHeader.validOrNot'},
            align:"center",
            dataIndex: 'validFlag_dictText'
          },
          {
            slotName: 'tableHeader.operation',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action', title: 'tableHeader.operation' }
          }
        ],
        url: {
          list: "/feeArchive/efsMdArchives/list",
          delete: "/feeArchive/efsMdArchives/delete",
          deleteBatch: "/feeArchive/efsMdArchives/deleteBatch",
          exportXlsUrl: "/feeArchive/efsMdArchives/exportXls",
          importExcelUrl: "feeArchive/efsMdArchives/importExcel",

        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig(){
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>